import { TrackActionResult } from "../../model/track-action-result";
import { RegistratioData } from "src/app/shared/model/registration-data";
import { TrackInfo } from "../../model/track-info";

export class CompanyActionV2 {

    public static execute(data: RegistratioData): TrackActionResult {
        const income: string = data.incomeEquity?.income;
        const patrimony: string = data.incomeEquity?.patrimony;

        const incomeRequired: boolean = data.professionalData?.incomeRequired;
        const patrimonyRequired: boolean = data.professionalData?.patrimonyRequired;

        if (incomeRequired && (!income || income === '' || income === '0.00' || income === '0,00')
        || patrimonyRequired && (!patrimony || patrimony === '' || patrimony === '0.00' || patrimony === '0,00')
        ) {
            const trackInfo = new TrackInfo('income-wealthincome', ['income', 'income-wealthincome']);
            return new TrackActionResult(data, trackInfo);
        } else {
            const trackInfo = new TrackInfo('client-data', ['data', 'client-data']);
            return new TrackActionResult(data, trackInfo);
        }
    }

}
